import type { PlayerInput } from "@arcade-hockey/shared";
import type { PlayerState } from "@arcade-hockey/sim";

// Fill in moveX/moveY on `input` to steer `player` toward (targetX, targetY).
// Inside `deadband` units of the target, command zero movement so bots don't
// jitter around their goal. Mutates `input` in place — zero allocations.
export function fillChase(
  input: PlayerInput,
  player: PlayerState,
  targetX: number,
  targetY: number,
  deadband: number,
): void {
  const dx = targetX - player.pos.x;
  const dy = targetY - player.pos.y;
  const dist = Math.hypot(dx, dy);
  if (dist > deadband) {
    input.moveX = dx / dist;
    input.moveY = dy / dist;
  } else {
    input.moveX = 0;
    input.moveY = 0;
  }
}
